import Style from './Sponsors.module.css'
import SponsorsCard2 from './SponsorsCard2'
import Header from '../../components/Header/Header'
import Banner from '../../components/banner/Banner'


const Sponsors = () => {
  return (
    <>
      <Header />
      {/* <Banner text="Sponsors" bg="spon-heading" /> */}
      <SponsorsCard2 />
    </>
  )
}

export default Sponsors